import { render } from "./TheC01ItemFormNotePanelShortage.vue?vue&type=template&id=f944f9c0&scoped=true&ts=true"
import script from "./TheC01ItemFormNotePanelShortage.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemFormNotePanelShortage.vue?vue&type=script&lang=ts"

import "./TheC01ItemFormNotePanelShortage.vue?vue&type=style&index=0&id=f944f9c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f944f9c0"]])

export default __exports__